import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountPayRequestsRoutingModule } from './account-pay-requests-routing.module';
import { ListingComponent } from './pages/listing/listing.component';


@NgModule({
  declarations: [
    ListingComponent
  ],
  imports: [
    CommonModule,
    AccountPayRequestsRoutingModule,
    SharedModule
  ]
})
export class AccountPayRequestsModule { }
